export const GAME_DELETE_RESET = 'GAME_DELETE_RESET'
export const GAME_DELETE_SET_ERROR = 'GAME_DELETE_SET_ERROR'
export const GAME_DELETE_SET_DELETED = 'GAME_DELETE_SET_DELETED'
export const GAME_DELETE_TOGGLE_LOADING = 'GAME_DELETE_TOGGLE_LOADING'
